import { RootState } from '../store';

export const selectCalculatedEdd = (state: RootState) => {
  return state.deliveryEstimate.calculatedEdd || null;
};

export const selectLatestEdd = (state: RootState) => {
  return state.deliveryEstimate.calculatedEdd?.onDate || state.deliveryEstimate.latestEdd || null;
};
